package com.macrofocus.eflux.animation

import com.macrofocus.common.selection.MutableSelection
import com.macrofocus.eflux.network.logical.LogicalBranchId

class SelectLinkAnimation(private val link: LogicalBranchId?, private val selection: MutableSelection<LogicalBranchId>, override val duration: Long) :
    Animation {
    override fun start() {
        if(link != null) {
            selection.setSelectedElement(link)
        } else {
            selection.clearSelection()
        }
    }

    override fun tick(time: Long) {
//       if(time > duration / 2) {
//           selection.setSelectedElement(link)
//       }
    }
}